import React from 'react';
import { useEffect,useState } from 'react';
import mapFunctions from './Mapfunctions.js';

function MapComponent() {

    const [hasData, setHasData] = useState(false);
    const [water, setWater] = useState([]);
    const [houses, setHouses] = useState([]);

    useEffect(() => {
        const interval = setInterval(() => {
            const viewDiv = document.getElementById('viewDiv');
            if (viewDiv) {
                clearInterval(interval);
                mapFunctions(setHasData,setWater,setHouses);
            }
        }, 100);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        // Event listener voor selectScenarioPanel4 (1D/2D selector)
        const panel4 = document.getElementById('selectScenarioPanel4');
        const panel1 = document.getElementById('selectScenarioPanel1');
        const panel3 = document.getElementById('selectScenarioPanel3');

        if (panel4 && panel1 && panel3) {
            const handlePanel4Change = () => {
                const b70Option = panel3.querySelector('option[value="B70"]');
                const b08Option = panel3.querySelector('option[value="B08"]');

                if (panel4.value === '1D') {
                    panel1.disabled = true;
                    // Disable B70 optie in panel3 bij 1D
                    if (b70Option) {
                        b70Option.disabled = true;
                    }
                    // Standaard BC2 selecteren bij 1D
                    panel3.value = 'BC2';
                    // Enable B08 optie bij 1D
                    if (b08Option) {
                        b08Option.disabled = false;
                    }
                } else {
                    panel1.disabled = false;
                    // Enable B70 optie bij 2D
                    if (b70Option) {
                        b70Option.disabled = false;
                    }
                    // Disable B08 optie in panel3 bij 2D
                    if (b08Option) {
                        b08Option.disabled = true;
                        // Als B08 is geselecteerd, switch naar BC2
                        if (panel3.value === 'B08') {
                            panel3.value = 'BC2';
                        }
                    }
                }
            };

            // Voer check uit bij mount
            handlePanel4Change();

            // Voeg event listener toe
            panel4.addEventListener('change', handlePanel4Change);

            // Cleanup
            return () => {
                panel4.removeEventListener('change', handlePanel4Change);
            };
        }
    }, []);

    return (
        <div className="mappage">
            <div id="viewDiv"></div>

            <div id="ScenarioTool" className="esri-widget">
                
                <label id="ScenarioToolTitel" htmlFor="selectScenarioPanel1"><b>Kies scenario</b></label>

                <select id="selectScenarioPanel2" className="form-control">
                    <option value="HS">Huidige situatie (SCI)</option>
                    <option value="TS">Toekomstige situatie (SCII)</option>
                </select>
                <select id="selectScenarioPanel4" className="form-control">                           
                    <option value="1D">1D</option>
                    <option value="2D">2D</option>								
                </select>	
                <select id="selectScenarioPanel3" className="form-control">
                    <option value="B08">Bui 08 (T2)</option>
                    <option value="BC2">Composiet (T2)</option>
                    <option value="B70">Blokbui 70mm (T=100 jaar)</option>
                </select>                               
                <select id="selectScenarioPanel1" className="form-control">                    
                    <option value="WoS">Water op straat</option>
                    <option value="RP">Risico panden</option>
                    <option value="WoSRP">Water op straat + Risico panden</option>
                </select>               

                <button className="esri-button" id="SetScenario" type="button">
                    <span>Set Scenario </span>
                    <span className="esri-icon esri-icon-refresh" aria-hidden="true"></span>
                </button>          
            </div>

            <div id="AnalyseTool" className="esri-widget">
                <p><b>Analyse water op straat</b><br/>(alleen Resultaten 2D)</p>
                <div id="teken">
                    <button
                        className="esri-button  geometry-button"
                        id="polygonBtn" title="Filter by polygon" value="polygon"
                    >
                        <span className="esri button esri-icon-polygon"></span>
                        <span>Teken een polygoon in</span>
                    </button>
                </div>

                <button className="esri-button" id="clearFilter" type="button">
                    Clear filter
                </button>
  
            </div>

            <div id="sketchresults" data-loading={hasData}>
                <div className='column'>
                    <h5>Risicopanden</h5>
                    <div className='column__data'>
                        <span className='material-icons'>flood</span>
                        <table border="1" cellPadding={0} cellSpacing={0}>
                            <thead><tr><th>Scenario</th><th>Type</th><th>Kaartlaag</th><th>Aantal</th></tr></thead>
                            <tbody id="houseslist">
                            {houses
                                    .sort((a, b) => (a.scenario + a.type).localeCompare(b.scenario + b.type))
                                    .map((houseItem, index) => (
                                        <tr key={index}>
                                            <td>{houseItem.scenario}</td>
                                            <td>{houseItem.type}</td>
                                            <td>{houseItem.kaartlaag}</td>
                                            <td>{houseItem.aantal}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='divider'></div>

                <div className='column'>
                    <h5>Volume water op straat</h5>
                    <div className='column__data'>
                        <span className='material-icons'>water_drop</span>
                        <table border="1" cellPadding={0} cellSpacing={0}>
                            <thead><tr><th>Scenario</th><th>Type</th><th>Kaartlaag</th><th>m<sup>3</sup></th></tr></thead>
                            <tbody id="waterlist">
                                {water
                                    .sort((a, b) => (a.scenario + a.type).localeCompare(b.scenario + b.type))
                                    .map((waterItem, index) => (
                                        <tr key={index}>
                                            <td>{waterItem.scenario}</td>
                                            <td>{waterItem.type}</td>
                                            <td>{waterItem.kaartlaag}</td>
                                            <td>{waterItem.aantal}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>


                    </div>
                </div>

            </div>
        </div>
    );
};

export default MapComponent;